/* @flow */
import { getQueryParams } from 'trustar/utils';

import {
  FETCH_ALL,
  SUBSCRIBE,
} from './action-types.js';


/**
 * Fetch all possible data feeds for user.
 */
export const fetchFeeds = (payload: Object = getQueryParams()) => ({
  type: FETCH_ALL,
  payload,
});

/**
 * Subscribe user's company to a data feed.
 */
export const subscribe = (id: string, credentials: ?Map<any, any> = null, origin: ?string) => ({
  type: SUBSCRIBE,
  payload: { id, credentials, origin },
});



// WEBPACK FOOTER //
// ./src/app/modules/data-feeds/actions.js